import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "12",
  height: "8",
  viewBox: "0 0 12 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M0.20143 1.56363L5.50446 7.11919C5.77721 7.40493 6.22279 7.40493 6.49554 7.11919L11.7986 1.56363C12.0671 1.28227 12.0671 0.829164 11.7986 0.547802C11.5258 0.262062 11.0802 0.262062 10.8075 0.547802L6 5.58422L1.19251 0.547802C0.919756 0.262061 0.474181 0.262061 0.20143 0.547802C-0.0671432 0.829164 -0.0671432 1.28227 0.20143 1.56363Z",
  fill: "#B2C0CD"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }